import '../../../styles/skelton/report-card-skelton.scss';
const ReportCardSkeleton = () => {
  return (
    <div className="report-card skeleton">
      <div className="report-card-body">
        {/* Header */}
        <div className="skeleton-text skeleton-header" />

        {/* Icon */}
        <div className="report-card-icon">
          <div className="skeleton-circle" />
        </div>

        {/* Value section */}
        <div className="report-card-text">
          <div className="report-value">
            <span className="skeleton-text skeleton-label" />
            <span className="skeleton-text skeleton-number" />
          </div>

          {/* Footer */}
          <div className="report-footer">
            <div className="skeleton-text skeleton-footer" />
            <div className="skeleton-text skeleton-footer" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportCardSkeleton;
